var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InputBase } from 'ui-kit/controllers/input-base';
import { useFieldState } from 'ui-kit/controllers/selects/hooks/use-field-state';
export var SearchInput = function (_a) {
    var labels = _a.labels, setSubscriber = _a.setSubscriber, rest = __rest(_a, ["labels", "setSubscriber"]);
    var userQuery = useFieldState({ key: 'searchString', initialValue: '', setSubscriber: setSubscriber });
    return (_jsx(InputBase, __assign({ withButton: true, value: userQuery, autoComplete: "off", labels: !userQuery ? labels : undefined }, rest)));
};
